import {Image, Box, HStack, Heading} from 'platform/foundation';
import styled from 'styled-components';

import i18n from '@dms/i18n';

const BannerImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const StyledLeftSide = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({theme}) => theme.getSize(6)};
  align-items: center;
  padding-bottom: ${({theme}) => theme.getSize(10)};
  @container (min-width: 564px) {
    gap: ${({theme}) => theme.getSize(12)};
    padding-bottom: ${({theme}) => theme.getSize(6)};
    align-items: start;
  }
`;

const StyledLogoAndText = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.getSize(6)};
  max-width: ${({theme}) => theme.getSize(70)};
  align-items: center;
  @container (min-width: 564px) {
    align-items: start;
    & > :nth-child(2) {
      text-align: left;
    }
  }
`;

const StyledContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  min-width: ${({theme}) => theme.getSize(80)};
  position: relative;
  overflow: hidden;
  border-radius: ${({theme}) => theme.radii.medium};
  max-width: 200px;
  margin: 0 auto;
  @container (min-width: 564px) {
    max-width: ${({theme}) => theme.getSize(180)};
    margin: unset;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  container-type: inline-size;
  container-name: test-drive-container;
`;

export const CarAuditAppBanner = () => (
  <StyledContainer>
    <StyledContentWrapper>
      <BannerImage>
        <Image width="100%" height="100%" src="/assets/images/ca_banner_background.png" />
      </BannerImage>
      <Box paddingTop={6} paddingHorizontal={6}>
        <HStack justify="center" wrap>
          <Box zIndex="base" flexGrow={1}>
            <StyledLeftSide>
              <StyledLogoAndText>
                <Box maxWidth={27}>
                  <Image src="/assets/images/ca_logo_test_drive.svg" />
                </Box>
                <Heading color="white" align="center" size={3}>
                  {i18n.t('entity.condition.labels.testDriveApp')}
                </Heading>
              </StyledLogoAndText>
              <HStack spacing={2}>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://apps.apple.com/sk/app/caraudit/id1486564011"
                >
                  <Image height={8} src="/assets/images/app_store_button.png" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://play.google.com/store/apps/details?id=app.caraudit"
                >
                  <Image height={8} src="/assets/images/google_play_button.png" />
                </a>
              </HStack>
            </StyledLeftSide>
          </Box>
          <Image fit="contain" maxHeight={60} src="/assets/images/teas_phone.png" />
        </HStack>
      </Box>
    </StyledContentWrapper>
  </StyledContainer>
);
